import React, { useEffect, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import PageStatusView from 'client/components/PageStatusView';

import DateContext from 'common/components/DatePicker/DateContext';
import GlobalCss from 'common/style/GlobalCss';
import fontLoader from 'common/utils/fontLoader';
import { IS_LOCAL_DEV, IS_EDITOR_MODE } from 'config/envVariable';
import { appBaseName } from 'config/basenames';
import useGetFonFamilyByI18nLang from 'common/hooks/useGetFonFamilyByI18nLang';
import ThemeProvider from 'common/components/Mui/ThemeProvider';

const Client = lazy(() => import(/* webpackChunkName: "client" */ 'client/Client'));
const RedirectForm = lazy(() =>
    import(/* webpackChunkName: "redirect_form" */ 'client/RedirectForm')
);
const Editor = lazy(() => import(/* webpackChunkName: "editor" */ 'editor/Editor'));
const DevLocalFirebaseLogin = lazy(() =>
    import(/* webpackChunkName: "editor_dev_login" */ 'editor/components/DevLocalFirebaseLogin')
);

function App() {
    const fontFamily = useGetFonFamilyByI18nLang({ isClient: !IS_EDITOR_MODE, isGlobal: true });
    useEffect(() => {
        fontLoader();
        document.title = '載入中­...';
    }, []);
    return (
        <DateContext>
            <GlobalCss fontFamily={fontFamily} />
            <ThemeProvider config={{ fontFamily }}>
                <Router basename={appBaseName}>
                    <Suspense fallback={null}>
                        <Switch>
                            {IS_LOCAL_DEV && (
                                <Route path="/dev_login" component={DevLocalFirebaseLogin} />
                            )}
                            <Route path="/:id/redirect" exact component={RedirectForm} />
                            <Route path="/:routeSponsor/:id/edit" exact component={Editor} />
                            <Route path="/:routeSponsor/:id/(response)?" exact component={Client} />
                            <Route component={PageStatusView} />
                        </Switch>
                    </Suspense>
                </Router>
            </ThemeProvider>
        </DateContext>
    );
}

export default App;
